const names = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGIN_FAILED_CLEAR_ERROR: 'LOGIN_FAILED_CLEAR_ERROR',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',

  LOADING_STARTED: 'LOADING_STARTED',
  LOADING_FINISHED: 'LOADING_FINISHED',

  LOAD_PRODUCTS_SUCCESS: 'LOAD_PRODUCTS_SUCCESS',
  LOAD_PRODUCTS_FAIL: 'LOAD_PRODUCTS_FAIL',
  LOAD_PRODUCTS_STARTED: 'LOAD_PRODUCTS_STARTED',
  LOAD_PRODUCTS_FINISHED: 'LOAD_PRODUCTS_FINISHED',

  INVITE_USER_SUCCESS: 'INVITE_USER_SUCCESS',

  LOAD_PROFILE_SUCCESS: 'LOAD_PROFILE_SUCCESS',
  LOAD_PROFILE_DETAILS_SUCCESS: 'LOAD_PROFILE_DETAILS_SUCCESS',
  UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_ERROR: 'UPDATE_PROFILE_ERROR',

  LOAD_ROLES_DATA_STARTED: 'LOAD_ROLES_DATA_STARTED',
  LOAD_ROLES_DATA_FAIL: 'LOAD_ROLES_DATA_FAIL',
  LOAD_ROLES_DATA_SUCCESS: 'LOAD_ROLES_DATA_SUCESS',
  CLEAN_ROLE_DATA: 'CLEAN_ROLE_DATA',

  LOAD_USER_PROFILE_META_DATA_SUCCESS: 'LOAD_USER_PROFILE_META_DATA_SUCCESS',
  LOAD_USER_PROFILE_META_DATA_ERROR: 'LOAD_USER_PROFILE_META_DATA_ERROR',

  UPDATE_ASSIGNED_ROLES: 'UPDATE_ASSIGNED_ROLES',
  CLEAR_ASSIGNED_ROLES: 'CLEAR_ASSIGNED_ROLES',

  SET_BULK_REMOVAL_ORGANIZATION_LIST: 'SET_BULK_REMOVAL_ORGANIZATION_LIST',
  SET_BULK_REMOVAL_ROLE_LIST: 'SET_BULK_REMOVAL_ROLE_LIST'
};

export default names;
